import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["branch", "toggle", "entry", "imagePreview", "imageTitle"]

  select(event) {
    this.selectedKey = event.currentTarget.dataset.editorSelectionKey
    this.markSelection()
  }

  entryTargetConnected(entry) {
    this.applySelection(entry)
  }

  showImage(event) {
    const source = event.currentTarget
    const imageUrl = source.dataset.editorImageUrl
    const imageTitle = source.dataset.editorImageTitle || "Bauteil-Bild"
    if (!imageUrl) return

    this.imagePreviewTarget.src = imageUrl
    this.imagePreviewTarget.alt = imageTitle
    this.imageTitleTarget.textContent = imageTitle
  }

  toggle(event) {
    const button = event.currentTarget
    const branch = document.getElementById(button.getAttribute("aria-controls"))
    if (!branch) return

    const expanded = button.getAttribute("aria-expanded") === "true"
    this.setExpanded(button, branch, !expanded)
  }

  expandAll() {
    this.toggleTargets.forEach((button) => {
      const branch = document.getElementById(button.getAttribute("aria-controls"))
      if (branch) this.setExpanded(button, branch, true)
    })
  }

  collapseAll() {
    this.toggleTargets.forEach((button) => {
      const branch = document.getElementById(button.getAttribute("aria-controls"))
      if (branch) this.setExpanded(button, branch, false)
    })
  }

  setExpanded(button, branch, expanded) {
    button.setAttribute("aria-expanded", expanded.toString())
    branch.hidden = !expanded

    const icon = button.querySelector("i")
    if (!icon) return

    icon.classList.toggle("fa-chevron-down", expanded)
    icon.classList.toggle("fa-chevron-right", !expanded)
  }

  markSelection() {
    this.entryTargets.forEach((entry) => this.applySelection(entry))
  }

  applySelection(entry) {
    const partSelected = entry.dataset.editorPartKey === this.selectedKey
    const assemblySelected = entry.dataset.editorAssemblyKey === this.selectedKey
    const newSelected = entry.dataset.editorNewKey === this.selectedKey

    entry.classList.toggle("is-editing-part", partSelected)
    entry.classList.toggle("is-editing-assembly", assemblySelected)
    entry.classList.toggle("is-creating-assembly", newSelected)
  }
}
